import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { IonContent, ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { SupportTicket, Messages } from 'src/app/interfaces/chat';
import { AccountService } from 'src/app/services/account/account.service';
import { AccountsListService } from 'src/app/services/accounts/accounts-list.service';
import { DateTimeService } from 'src/app/services/general/date-time.service';
import { FunctionService } from 'src/app/services/general/function.service';
import { PhotoService } from 'src/app/services/general/photo.service';
import { SupportDbService } from 'src/app/services/support/support-db.service';
import { SupportTicketService } from 'src/app/services/support/support-ticket.service';
import { UpdateByService } from 'src/app/services/user/update-by.service';
import { UserService } from 'src/app/services/user/user.service';
import { AccountsListComponent } from '../../accounts/accounts-list/accounts-list.component';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { LinkService } from 'src/app/services/general/link.service';
import { NavigationExtras, Router } from '@angular/router';

import { SupportUrl } from 'src/app/commons/url';
import { SupportType } from 'src/app/types/general';
import { SupportStatus, SupportTicketType } from 'src/app/types/chat';
import { PopupService } from 'src/app/services/general/popup.service';
import { LanguageService } from 'src/app/services/general/language.service';

import { PermissionState } from '@capacitor/core';
import linkifyHtml from "linkify-html";
import { DeviceTokenService } from 'src/app/services/device/device-token.service';

@Component({
  selector: 'app-ticket-detail',
  templateUrl: './ticket-detail.component.html',
  styleUrls: ['./ticket-detail.component.scss'],
})
export class TicketDetailComponent  implements OnInit, OnDestroy {

  @ViewChild(CdkVirtualScrollViewport) cdkVirtualScrollViewport: CdkVirtualScrollViewport;
  
  @ViewChild('content') private content: IonContent;
  
  @ViewChild('content', { read: ElementRef }) contentElement: ElementRef;

  /**
   * Header for getting header height
   */
  @ViewChild('header', { read: ElementRef, static: false }) header: ElementRef;
  /**
   * Footer for getting footer height
   */
  @ViewChild('footer', { read: ElementRef, static: false }) footer: ElementRef;

  @Input() pageMode: boolean;

  @Input() private backHelpPage: boolean;

  @Input() private backRatingPage: boolean;

  @Input() private backInboxPage: boolean;

  @Input() supportTicket: SupportTicket;

  @Input() ticketId: string;

  @Output() setTicketId  = new EventEmitter<string>();
  @Output() setSupportTicket  = new EventEmitter<SupportTicket>();

  @Input() set ready(ready: boolean) {
    if (ready) {
      this.initalize();
    } else {
      this.unwatchSupport();
      this.supportTicket = null;
    }
  }

  permissionStatus: PermissionState | NotificationPermission;

  star: {
    one: boolean,
    two: boolean,
    three: boolean,
    four: boolean,
    five: boolean,
  };
  starColor: string;

  ticketType: SupportTicketType;
  
  supportForm: FormGroup;
  /**
   * Validation msg
   */
  validationMsg: any;
  
  newMode: boolean;

  

  // attachments: string[] = [];

  message: string;

  dateList: string[] = [];

  messagesList: Messages[] = [];

  msgList: {
    [date:string]: Messages[]
  };

  private supportListSubscription: Subscription;

  constructor(
    private router: Router,
    private translate: TranslateService,
    private formBuilder: FormBuilder,
    private modalController: ModalController,
    private accountService: AccountService,
    private accountsListService: AccountsListService,
    private userService: UserService,
    private supportDbService: SupportDbService,
    private supportTicketService: SupportTicketService,
    private deviceTokenService: DeviceTokenService,
    private languageService: LanguageService,
    private dateTimeService: DateTimeService,
    private photoService: PhotoService,
    private linkService: LinkService,
    private functionService: FunctionService,
    private updateByService: UpdateByService,
    private popupService: PopupService,
  ) { }

  ngOnInit() {}
  
  ngOnDestroy(): void {
      this.unwatchSupport();
  }

  ionViewWillEnter() {
    this.initalize();
  }

  ionViewWillLeave() {
    this.unwatchSupport();
    this.supportTicket = null;
  }

  async initalize() {
    this.photoService.supportAttachementList = [];
    this.message = '';

    this.watchSupport();

    this.permissionStatus = await this.deviceTokenService.getPermissionStatus();

    if (this.supportTicket?.ticketId || this.ticketId) {
      this.setupMessagesList();
      this.newMode = false;
    } else {
      this.ticketType = '';
      this.newMode = true;
    }
  }

  async watchSupport() {
    if (!this.supportListSubscription) {
      this.supportListSubscription = this.supportTicketService.observableSupportTicketList.subscribe(() => {
        if (this.supportTicket?.ticketId || this.ticketId) {
          this.supportTicket = this.supportTicketService.getSupportTicketById(this.supportTicket?.ticketId ? this.supportTicket.ticketId : this.ticketId);
          if (this.supportTicket?.ticketId && this.supportTicket?.messages) {
            this.setupMessagesList();
            this.setupRating();
          } else {
            this.dismissModal();
          }
        }
      });
    }
  }

  async unwatchSupport() {
    if (this.supportListSubscription) {
      this.supportListSubscription.unsubscribe();
      this.supportListSubscription = null;
    }
  }

  async setupForm() {
    this.validationMsg = {
      accountId: [{ type: 'required', msg: this.translate.instant('VALIDATION.required', { field: this.translate.instant('MODULE.list.account') }) }],
      msg: [{ type: 'required', msg: this.translate.instant('VALIDATION.required', { field: this.translate.instant('LBL.type') }) }],
    };

    this.supportForm = this.formBuilder.group({
      accountId: new FormControl(this.accountService.accountId ? this.accountService.accountId : '', []),
      msg: new FormControl('', [ Validators.required ]),
    });
  }

  setupMessagesList() {
    let messagesList = [];
    let dateList = [];

    if (this.supportTicket?.messages) {
      Object.keys(this.supportTicket.messages).forEach((key: string) => {
        if (this.supportTicket.messages[key]) {
          const msg = this.supportTicket.messages[key];
          messagesList.push(msg);
        };
      });
    }

    messagesList = messagesList.sort((a: Messages, b: Messages) => {
      return this.functionService.compare(a.createBy.time, b.createBy.time);
    });

    messagesList.forEach((msg: Messages) => {
      const date = this.format(msg.createBy.time, 'do MMM yyyy');
      if (date && dateList?.indexOf(date) === -1) {
        dateList.push(date);
      }
    });

    this.messagesList = messagesList;
    this.dateList = dateList;

    this.setupMsgList();

    this.supportTicketService.updateMsgRead(this.supportTicket?.ticketId);
    

    // this.setupViewport();
    // 
    // setTimeout(() => {
    //   this.cdkVirtualScrollViewport.scrollTo({ bottom: 0, behavior: 'smooth' });
    // }, 0);
    
  }

  setupMsgList() {
    if (!this.msgList) {
      this.msgList = {};
    }
    this.dateList?.forEach((date: string) => {
      this.msgList[date] = this.getMsgList(date);
    });

    this.scrollToBottom();
  }

  setupRating() {
    if (this.supportTicket?.ticketStatus === 'resolved' || this.supportTicket?.ticketStatus === 'closed') {
      if (this.supportTicket?.rating) {
        this.star = {
          one: true,
          two: this.supportTicket.rating >= 2 ? true : false,
          three: this.supportTicket.rating >= 3 ? true : false,
          four: this.supportTicket.rating >= 4 ? true : false,
          five: this.supportTicket.rating >= 5 ? true : false,
        };
      }
      this.setupRatingColor();
    }
  }

  setupRatingColor() {
    this.starColor = this.getRatingColor();
  }

  getMsgList(selected: string) {
    let messagesList = [];
    if (selected) {
      this.messagesList.forEach((msg: Messages) => {
        const date = this.format(msg.createBy.time, 'do MMM yyyy');
        if (selected === date) {
          messagesList.push(msg);
        }
      });

      messagesList = messagesList.sort((a: Messages, b: Messages) => {
        return this.functionService.compare(a.createBy.time, b.createBy.time);
      });
    }
    return messagesList;
  }

  setupViewport() {
    if (this.cdkVirtualScrollViewport) {
      setTimeout(() => {
        this.cdkVirtualScrollViewport?.checkViewportSize();
      }, 200);
    } else {
      setTimeout(() => {
        this.setupViewport();
      }, 200);
    }
  }

  back() {
    if (this.newMode) {
      if (this.ticketType) {
        this.ticketType = '';
      } else {
        this.close();
      }
    } else {
      this.close();
    }
  }

  close() {
    if (this.pageMode) {
      this.unwatchSupport();
      if (this.backHelpPage) {
        this.router.navigate(['/about/help']);
      } else if (this.backRatingPage) {
        this.router.navigate(['/about/app-rating/true']);
      } else if (this.backInboxPage) {
        this.router.navigate(['/inbox/home/support']);
      } else {
        this.linkService.goMainPage();
      }
      this.supportTicket = null;
    } else {
      this.dismissModal();
    }
  }

  async dismissModal() {
    if (this.modalController) {
      const modal = await this.modalController.getTop();
      if (modal) { await modal.dismiss(); }
    }
  }

  async presentAccountsListModal() {
    const modal = await this.modalController.create({
      component: AccountsListComponent,
      componentProps: {
        selected: this.supportForm.value.accountId,
        supportTicktType: this.ticketType,
      }
    });
    modal.present();
    modal.onWillDismiss().then((result: any) => {
      if (result?.data?.selected) {
        if (this.supportForm.value.accountId !== result.data.selected) {
          this.supportForm.controls.accountId.setValue(result.data.selected);
        }
      }
    });
  }

  getUser() {
    return this.userService.user;
  }

  getUid() {
    return this.userService.uid;
  }

  getSupportAttachmentList(): string[] {
    return this.photoService.supportAttachementList;
  }

  getAccountTitle(accountId: string) {
    return this.accountsListService.getAccountTitle(accountId);
  }

  getRatingColor() {
    if (this.star) {
      if (this.star?.five || this.star?.four) {
        return 'success'
      } else if (this.star?.three) {
        return 'primary'
      } else {
        return 'danger'
      }
    }
    
    return ''
  }

  getRatingNumber() {
    if (this.star) {
      if (this.star?.five) {
        return 5;
      } else if (this.star?.four) {
        return 4;
      } else if (this.star?.three) {
        return 3;
      } else if (this.star?.two) {
        return 2;
      } else if (this.star?.one) {
        return 1;
      }
    }
    return 0;
  }

  getHtml(html: string) {
    const htmlTagStartIndex = html.indexOf('<html>');
    const htmlTagEndIndex = html.indexOf('</html>');
    if (htmlTagStartIndex !== -1 && htmlTagEndIndex !== -1) {
     html = this.functionService.replaceAll(html, '<html>', '');
     html = this.functionService.replaceAll(html, '</html>', '');
     html = this.functionService.replaceAll(html, '<', '&lt;');
     html = this.functionService.replaceAll(html, '>', '&gt;');
    }
     return linkifyHtml(html, { target: { url: '_blank' }});
   }

  format(timestamp: number, dateTimeFormat?: string, timezone?: string) {
    if (this.functionService.isNumber(timestamp)) {
      return this.dateTimeService.format(timestamp, dateTimeFormat, '', timezone);
    }
    return '';
  }

  setTicketType(ticketType: SupportTicketType) {
    this.ticketType = ticketType;
    this.setupForm();
  }

  typeChanged(event: any) {
    if (this.supportForm?.value?.type === 'refund' || this.supportForm?.value?.type === 'aup_appeal') {
      this.supportForm.controls.accountId.setValidators([ Validators.required ]);
    } else {
      this.supportForm.controls.accountId.setValidators([]);
    }
    this.supportForm.controls.accountId.updateValueAndValidity();
  }

  resetAccount() {
    this.supportForm.controls.accountId.setValue('');
  }

  async selectPhoto() {
    this.photoService.selectPhoto('support_attachment', true);
  }

  async deletePhoto(index: number) {
    this.photoService.supportAttachementList.splice(index, 1);
  }

  async generateSupportTicket(): Promise<SupportTicket> {
    const updateBy = this.updateByService.updateBy;
    updateBy.time = this.functionService.firebaseServerTime;

    if (this.supportTicket?.ticketId) {
      const supportTicket: SupportTicket = this.supportTicket;
      supportTicket.updateBy = updateBy;
      
      const message = await this.generateMessage(supportTicket.ticketId);
      if (message?.messageId) {
        if (!supportTicket?.messages) {
          supportTicket.messages = {};
        }
        supportTicket.messages[message.messageId] = message;
      }

      return supportTicket;
    } else {
      const ticketId = this.supportDbService.generateTicketId(this.userService.uid);

      const supportTicket: SupportTicket = {
        ticketId,
        ticketType: this.ticketType,
        ticketStatus: 'in_progress',
        accountId: this.supportForm.value.accountId,
        primaryMessageId: '',
        rating: 0,
        name: this.userService.user.name,
        email: this.userService.user.email,
        whatsapp: this.userService.user.mobile,
        userLanguage: this.languageService.getUserLanguage()?.code,
        uid: this.getUid(),
        messages: {},
        createBy: updateBy,
        updateBy,
      };
      if (!supportTicket?.userLanguage) {
        supportTicket.userLanguage = '';
      }
      if (!supportTicket?.email) {
        supportTicket.email = '';
      }
      if (!supportTicket?.whatsapp?.no) {
        supportTicket.whatsapp = {
          code: supportTicket?.whatsapp?.code ? supportTicket.whatsapp.code : 0,
          no: '',
        };
      }
      const message = await this.generateMessage(ticketId);
      if (message?.messageId) {
        supportTicket.primaryMessageId = message.messageId;
        if (!supportTicket?.messages) {
          supportTicket.messages = {};
        }
        supportTicket.messages[message.messageId] = message;
      }
      return supportTicket;
    }
  }

  async generateMessage(ticketId: string): Promise<Messages> {
    const updateBy = this.updateByService.updateBy;
    updateBy.time = this.functionService.firebaseServerTime;
    
    const messageId = this.supportDbService.generateMessagesId(this.userService.uid, ticketId);
    let uid = this.supportTicket?.uid ? this.supportTicket.uid : this.userService.uid;
    const attachments = await this.photoService.uploadSupportTicketAttachment(ticketId, uid, this.photoService.supportAttachementList);
    const message: Messages = {
      messageId,
      messageType: 'support',
      message: this.supportForm?.value?.msg ? this.supportForm.value.msg : this.message,
      attachments,
      status: {
        [this.getUid()]: {
          uid: this.getUid(),
        }
      },
      createBy: updateBy,
      updateBy,
    }
    return message;
    
  }

  goTicketDetailPage(supportTicket?: SupportTicket) {
    if (supportTicket?.ticketId) {
      const navigationExtras: NavigationExtras = {
        state: { supportTicket }
      };
      this.router.navigate([ '/chat/ticket-detail/' + supportTicket.ticketId ], navigationExtras);
    } else {
      this.router.navigate([ '/chat/ticket-detail' ]);
    }
  }

  async supportFormSubmit() {
    this.supportForm.markAllAsTouched();
    if (this.supportForm.valid) {
      await this.popupService.presentLoading();
      const supportTicket = await this.generateSupportTicket();
      await this.supportTicketService.updateTicket(supportTicket);
      this.photoService.supportAttachementList = [];
      this.message = '';
      
      this.supportTicket = this.functionService.cloneDeep(supportTicket);
      await this.watchSupport();
      this.supportForm.reset();

      if (this.pageMode) {
        this.goTicketDetailPage(this.supportTicket);
      }
      this.newMode = false;
      await this.popupService.dismissLoading();
    }
  }

  async submit() {
    await this.popupService.presentLoading();
    if (this.supportTicket?.ticketId) {
      const message = await this.generateMessage(this.supportTicket.ticketId);
      if (message?.attachments?.length || message?.message) {
        await this.supportTicketService.updateMsg(this.supportTicket.ticketId, message);
      }
    } else {
      const supportTicket = await this.generateSupportTicket();
      await this.supportTicketService.updateTicket(supportTicket);
    }
    
    this.photoService.supportAttachementList = [];
    this.message = '';
    this.newMode = false;

    if (this.supportTicket?.ticketStatus === 'closed') {
      this.updateTicketStatus('in_progress');
    }
    await this.popupService.dismissLoading();
  }

  updateTicketStatus(ticketStatus: SupportStatus) {
    if (ticketStatus && this.supportTicket?.ticketId) {
      this.supportTicket.ticketStatus = ticketStatus;
      this.supportTicketService.updateTicketStatus(this.supportTicket.uid, this.supportTicket.ticketId, ticketStatus);
    }
  }

  updateTicketRating(pos: string) {
    if (!this.star) {
      this.star = {
        one: false,
        two: false,
        three: false,
        four: false,
        five: false,
      };
    }
    if (!this.star[pos]) {
      this.star[pos] = true;
    }

    if (pos === 'one') {
      if (this.star[pos]) {
        Object.keys(this.star).forEach((key: string) => {
          if (key !== 'one') {
            this.star[key] = false;
          }
        });
      }
    } else if (pos === 'two') {
      if (this.star[pos]) {
        Object.keys(this.star).forEach((key: string) => {
          if (key !== 'one' && key !== 'two') {
            this.star[key] = false;
          } else {
            this.star[key] = true;
          }
        });
      } else {
        Object.keys(this.star).forEach((key: string) => {
          if (key !== 'five' && key !== 'four' && key !== 'three') {
            this.star[key] = true;
          } else {
            this.star[key] = false;
          }
        });
      }
    } else if (pos === 'three') {
      if (this.star[pos]) {
        Object.keys(this.star).forEach((key: string) => {
          if (key !== 'one' && key !== 'two' && key !== 'three') {
            this.star[key] = false;
          } else {
            this.star[key] = true;
          }
        });
      } else {
        Object.keys(this.star).forEach((key: string) => {
          if (key !== 'five' && key !== 'four') {
            this.star[key] = true;
          } else {
            this.star[key] = false;
          }
        });
      }
    } else if (pos === 'four') {
      if (this.star[pos]) {
        Object.keys(this.star).forEach((key: string) => {
          if (key !== 'one' && key !== 'two' && key !== 'three' && key !== 'four') {
            this.star[key] = false;
          } else {
            this.star[key] = true;
          }
        });
      } else {
        Object.keys(this.star).forEach((key: string) => {
          if (key !== 'five') {
            this.star[key] = true;
          } else {
            this.star[key] = false;
          }
        });
      }
    } else if (pos === 'five') {
      if (this.star[pos]) {
        Object.keys(this.star).forEach((key: string) => {
          if (key !== 'one' && key !== 'two' && key !== 'three' && key !== 'four' && key !== 'five') {
            this.star[key] = false;
          } else {
            this.star[key] = true;
          }
        });
      } else {
        Object.keys(this.star).forEach((key: string) => {
          this.star[key] = true;
        });
      }
    }

    this.supportTicketService.updateTicketRating(this.supportTicket.uid, this.supportTicket.ticketId, this.getRatingNumber());
  }

  /**
   * Open support type
   * @param type Support type
   */
  open(type: SupportType) {
    if (type && SupportUrl) {
      const url = SupportUrl?.[type];
      if (url) {
        if (type === 'facebook') {
          this.openUrl(url);
        } else {
          window.open(url, '_system');
        }
      }
    }
  }

  async requestPermission() {
    if (this.permissionStatus !== 'granted') {
      await this.deviceTokenService.manualRequestPermission();
    }
    this.permissionStatus = await this.deviceTokenService.getPermissionStatus();
  }

  openUrl(url: string) {
    this.linkService.openUrl(url);
  }

  goHelpCenter() {
    this.linkService.goHelpCenter();
  }

  scrollToBottom(time?: number) {
    setTimeout(() => {
      this.content?.scrollToBottom(time ? time : 0);
    }, 300);
  }

  trackByFn(index: number, item: Messages) {
    if (item?.messageId) {
      return item?.messageId;
    }
    return index;
  }

}
